// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from '@tanstack/react-start'
import { supabase } from './client'

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
async function getTokenWithRetry(): Promise<string | undefined> {
  // Poll briefly for the session to hydrate from storage. Without this, the
  // first server-fn call right after page load can fire before Supabase has
  // restored the session → RLS sees auth.uid()=null → 0 rows.
  const deadline = Date.now() + 800
  while (true) {
    const { data } = await supabase.auth.getSession()
    const token = data.session?.access_token
    if (token) return token
    if (Date.now() >= deadline) return undefined
    await new Promise((r) => setTimeout(r, 50))
  }
}

export const attachSupabaseAuth = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    const token = await getTokenWithRetry()
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
  },
)
